var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCt4(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #fff200;\n        stroke: #231f20;\n        stroke-miterlimit: 10;\n        stroke-width: 4px;\n      }\n\n      .cls-2 {\n        fill: #231f20;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 22,
    cy: 22,
    r: 20
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M23.81,32.18v-2.89h-7.85c-1,0-1.74-.23-2.23-.68s-.74-1.05-.74-1.82c0-.21,.04-.41,.12-.61,.06-.21,.18-.43,.31-.64,.16-.21,.31-.45,.47-.64,.16-.21,.33-.47,.57-.76l8.28-11.09c.55-.72,1-1.25,1.35-1.58,.33-.33,.76-.49,1.25-.49,1.58,0,2.38,.9,2.38,2.71v12.09h.66c.8,0,1.45,.12,1.93,.33s.72,.7,.72,1.45c0,.61-.2,1.04-.59,1.31-.41,.29-1,.43-1.8,.43h-.94v2.89c0,.8-.18,1.41-.55,1.8-.35,.39-.82,.59-1.41,.59s-1.05-.2-1.43-.61c-.35-.39-.53-1-.53-1.78Zm-6.72-6.41h6.72v-9.06l-6.72,9.06Z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCt4);
export default __webpack_public_path__ + "static/media/CT4.2c02000c2e22f594e5dbbf6b2a6e9cc5.svg";
export { ForwardRef as ReactComponent };